/* Onnenpyörä: storefrontin widget. Arvonta ja koodit tehdään palvelimella (/apps/onnenpyora/spin),
   tai selaimessa, kun konfiguraatiossa on local (teema ilman sovellusta, ks. localSpin). */
(function () {
  "use strict";
  var script = document.currentScript;
  var cfg;
  try {
    cfg = JSON.parse(script.dataset.config);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.slices || cfg.slices.length < 2) return;

  var preview = script.dataset.preview === "true";
  // Demo (sovelluksen esikatselu ja teemaeditori): arvonta selaimessa, ei oikeita koodeja eikä tallennusta.
  var demo = script.dataset.demo === "true";
  // Paikallinen arvonta (sahkopyoratukku.fi:n teema, ei sovellusta): painotettu arvonta selaimessa, kiinteät koodit,
  // käytetyt osoitteet tämän selaimen muistissa. Teema kuulee tuloksen onnenpyora:spin-tapahtumasta (Klaviyo-meili).
  var local = cfg.local || null;
  var KEY_USED = "onnenpyora:used";
  var root = (script.dataset.root || "/").replace(/\/?$/, "/"); // kaupan juuri kieliversioineen, esim. /en/
  var endpoint = root + "apps/onnenpyora/spin";
  var shopName = script.dataset.shop || "";
  var KEY_SEEN = "onnenpyora:seen";
  var KEY_RESULT = "onnenpyora:result";
  var KEY_START = "onnenpyora:start";
  var DAY = 864e5;
  // Osoittimen naksahdus: vahva ease-out.
  var EASE_OUT = "cubic-bezier(0.23, 1, 0.32, 1)";
  var PULL_MS = 380, PULL_DEG = 10; // ennakoiva taaksepäin veto
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var n = cfg.slices.length;
  var sliceDeg = 360 / n;

  var store = {
    get: function (k) {
      if (demo) return null;
      try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; }
    },
    set: function (k, v) {
      if (demo) return;
      try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* yksityinen tila */ }
    }
  };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function euros(v) { return v + " €"; }
  function date(iso) { return new Date(iso).toLocaleDateString("fi-FI"); }
  // SVG:n oma rotate keskipisteen (100,100) ympäri. CSS-transform + transform-origin pikseleinä
  // kiersi Safarissa väärän akselin ympäri, kun sivua oli zoomattu.
  function setRotor(deg) { rotor.setAttribute("transform", "rotate(" + deg + " 100 100)"); }

  // Geometria SVG-yksiköissä: lohkot r=100 ohuella kehällä, osoitin kehän yllä. Keskipiste (100,100).
  function pt(a, rad) { return (100 + rad * Math.sin(a)).toFixed(2) + "," + (100 - rad * Math.cos(a)).toFixed(2); }
  function circle(cls, a, rad, size) {
    var p = pt(a, rad).split(",");
    return '<circle class="' + cls + '" cx="' + p[0] + '" cy="' + p[1] + '" r="' + size + '"/>';
  }

  // Teksti poikittain: osoittimen alle pysähtyvä lohko luetaan suoraan. Voitossa iso summa ja pieni ALE.
  function sliceLabel(s) {
    var big = n > 8 ? 13 : 18, small = n > 8 ? 9 : 11;
    function t(y, size, txt, cls) {
      return '<text x="100" y="' + y + '" font-size="' + size + '"' + (cls ? ' class="' + cls + '"' : "") + ">" + esc(txt) + "</text>";
    }
    if (s.amount > 0) return t(31, big, euros(s.amount)) + t(47, 8.5, "ALE", "opw-ale");
    var words = String(s.label).split(" ");
    if (words.length === 1) return t(36, small, words[0]);
    return t(29, small, words[0]) + t(42, small, words.slice(1).join(" "));
  }

  function wheelSvg() {
    var step = (2 * Math.PI) / n, slices = "", pegs = "";
    cfg.slices.forEach(function (s, i) {
      var d = "M100,100 L" + pt((i - 0.5) * step, 100) + " A100,100 0 0 1 " + pt((i + 0.5) * step, 100) + " Z";
      slices += '<g class="opw-slice"><path d="' + d + '" fill="' + esc(s.color) + '"/>' +
        '<g transform="rotate(' + ((i * 360) / n).toFixed(3) + ' 100 100)" fill="' + esc(s.text) + '">' + sliceLabel(s) + "</g>" +
        '<path class="opw-shade" d="' + d + '"/></g>';
      pegs += circle("opw-peg", (i + 0.5) * step, 100, 2.4); // lohkorajalla, kehän päällä
    });
    return '<svg class="opw-wheel" viewBox="-18 -18 236 236" aria-hidden="true" focusable="false">' +
      '<g class="opw-rotor">' + slices + '<circle class="opw-rim" cx="100" cy="100" r="100"/>' + pegs + "</g>" +
      '<g class="opw-hub"><circle cx="100" cy="100" r="17"/><path d="M102.5,88 L93,102 H99 L97.5,112 L107,97.5 H101 Z"/></g>' +
      '<path class="opw-pointer" d="M89,-16 H111 L100,6 Z"/></svg>';
  }

  function rulesHtml() {
    var items = cfg.rules.map(function (p) {
      return "<li>" + esc(p.label) + ": alennus " + euros(p.amount) + " vähintään " + euros(p.minSubtotal) + " tilauksesta</li>";
    }).join("");
    return "<ul>" + items + "</ul><p>Jokainen sähköpostiosoite voi pyörittää kerran. " +
      (cfg.codeValidDays ? "Voittokoodi on kertakäyttöinen ja voimassa " + cfg.codeValidDays + " päivää. " : "Voittokoodin voi käyttää kerran. ") +
      "Koodia ei voi yhdistää muihin alennuksiin eikä vaihtaa rahaksi. Osallistuminen ei edellytä ostosta. " +
      "Pyöräyttämällä liityt uutiskirjeemme tilaajaksi. Voit perua tilauksen milloin tahansa." +
      (shopName ? " Järjestäjä: " + esc(shopName) + "." : "") + "</p>";
  }

  function resultHtml(data, repeat) {
    var done = '<button type="button" class="opw-btn opw-done">Jatka ostoksia</button>';
    if (data.win && !data.code) {
      // Palvelin ei palauta koodia uudelleen (suojaa toisen osoitteella kalastelulta).
      return '<h2 class="opw-title">Olet jo pyörittänyt</h2>' +
        "<p>Tällä osoitteella on jo voitettu " + euros(data.amount) + " alennus. Koodi näytettiin pyöräytyksen jälkeen. Jos se on hukassa, ota yhteyttä asiakaspalveluumme.</p>" + done;
    }
    if (!data.win) {
      return '<h2 class="opw-title">' + (repeat ? "Olet jo pyörittänyt" : "Ei voittoa tällä kertaa") + "</h2>" +
        "<p>Kiitos osallistumisesta! Uutiskirjeen tilaajana kuulet tarjouksistamme ensimmäisenä.</p>" + done;
    }
    return '<h2 class="opw-title">' + (repeat ? "Voittosi odottaa" : "Onneksi olkoon!") + "</h2>" +
      '<p class="opw-prize">' + euros(data.amount) + " alennus</p>" +
      "<p>Koskee vähintään " + euros(data.minSubtotal) + " tilausta." +
        (data.expiresAt ? " Koodi on voimassa " + date(data.expiresAt) + " asti." : "") + "</p>" +
      '<div class="opw-code"><span>' + esc(data.code) + '</span><button type="button" class="opw-copy">Kopioi</button></div>' +
      done +
      '<p class="opw-note">Alennus on jo lisätty ostoskoriisi, joten se näkyy kassalla automaattisesti.</p>';
  }

  // Suurin mahdollinen voittonäkymä varaa tilan valmiiksi, jotta laatikko ei kasva tuloksen tullessa.
  var maxPrize = cfg.rules.reduce(function (m, p) { return p.amount > m.amount ? p : m; }, { amount: 0, minSubtotal: 0 });
  var sizer = { win: true, code: "ONNI000-XXXXXX", amount: maxPrize.amount || 100, minSubtotal: maxPrize.minSubtotal || 1000,
    expiresAt: cfg.codeValidDays ? new Date().toISOString() : null };

  var dialog = document.createElement("dialog");
  dialog.className = "opw";
  dialog.setAttribute("aria-labelledby", "opw-title");
  dialog.style.setProperty("--opw-accent", cfg.accentColor);
  dialog.style.setProperty("--opw-accent-text", cfg.accentText);
  dialog.innerHTML =
    '<button type="button" class="opw-close" aria-label="Sulje">&times;</button>' +
    '<div class="opw-grid">' +
      // Osoitin on osa pyörän SVG:tä, joten se pysyy kohdallaan kaikilla näytöillä.
      '<div class="opw-stage">' + wheelSvg() +
        // Demon uusintanappi on kulmassa absoluuttisesti, jotta laatikon mitat ovat samat kuin kaupassa.
        // Se on aina valmiina, koska testiosoite voi kytkeä demon päälle kesken sivun.
        '<button type="button" class="opw-again" aria-label="Pyöritä uudelleen" title="Pyöritä uudelleen" hidden>&#8635;</button>' +
      "</div>" +
      '<div class="opw-body">' +
        '<div class="opw-panes">' +
          '<div class="opw-pane opw-pane-form">' +
            '<h2 id="opw-title" class="opw-title">' + esc(cfg.title) + '</h2><p class="opw-sub">' + esc(cfg.subtitle) + "</p>" +
            '<form class="opw-form" novalidate>' +
              '<label class="opw-label" for="opw-email">Sähköpostiosoite</label>' +
              // Virhe kentän alla samassa kääreessä: tyhjänä se ei vie tilaa lomakkeen välistyksestä.
              '<div class="opw-field">' +
                '<input class="opw-input" id="opw-email" name="email" type="email" autocomplete="email" inputmode="email" required aria-describedby="opw-msg">' +
                '<p class="opw-msg" id="opw-msg" role="status" aria-live="polite"></p>' +
              "</div>" +
              '<button type="submit" class="opw-btn">' + esc(cfg.buttonText) + "</button>" +
              '<p class="opw-legal">Pyöräyttämällä hyväksyt, että saat meiltä tarjouksia ja uutisia sähköpostitse. Voit perua tilauksen milloin tahansa. ' +
                '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Tietosuojaseloste</a> · ' +
                '<button type="button" class="opw-rules-link" aria-expanded="false" aria-controls="opw-rules">Säännöt</button></p>' +
            "</form>" +
          "</div>" +
          '<div class="opw-pane opw-pane-result" tabindex="-1" inert>' + resultHtml(sizer, false) + "</div>" +
        "</div>" +
        // Säännöt avautuvat saman alueen päälle (ei kasvata laatikkoa); pitkä teksti vierii sisällä.
        '<div class="opw-rules" id="opw-rules" role="region" aria-labelledby="opw-rules-title" hidden>' +
          '<h3 id="opw-rules-title" class="opw-rules-title" tabindex="-1">Säännöt</h3>' + rulesHtml() +
          '<button type="button" class="opw-rules-back">Takaisin</button>' +
        "</div>" +
      "</div>" +
    "</div>";

  var launcher = document.createElement("button");
  launcher.type = "button";
  launcher.className = "opw-launcher";
  launcher.hidden = true;
  launcher.textContent = "Onnenpyörä";
  launcher.style.setProperty("--opw-accent", cfg.accentColor);
  launcher.style.setProperty("--opw-accent-text", cfg.accentText);

  var form = dialog.querySelector(".opw-form");
  var msg = dialog.querySelector(".opw-msg");
  var submitBtn = dialog.querySelector(".opw-form .opw-btn");
  var formPane = dialog.querySelector(".opw-pane-form");
  var resultPane = dialog.querySelector(".opw-pane-result");
  var rotor = dialog.querySelector(".opw-rotor");
  var pointer = dialog.querySelector(".opw-pointer");
  if (demo) form.email.value = "demo@esimerkki.fi";

  function open() {
    store.set(KEY_SEEN, Date.now());
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add("opw-lock");
    var saved = store.get(KEY_RESULT);
    if (saved) showResult(saved, true);
    else form.email.focus();
  }

  dialog.addEventListener("close", function () {
    document.documentElement.classList.remove("opw-lock");
    launcher.hidden = false;
    if (demo) reset();
  });
  dialog.querySelector(".opw-close").addEventListener("click", function () { dialog.close(); });
  dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
  launcher.addEventListener("click", open);

  var rulesLink = dialog.querySelector(".opw-rules-link");
  var rules = dialog.querySelector(".opw-rules");
  function toggleRules(show) {
    rules.hidden = !show;
    rulesLink.setAttribute("aria-expanded", String(show));
    if (show) rules.querySelector(".opw-rules-title").focus();
    else rulesLink.focus();
  }
  rulesLink.addEventListener("click", function () { toggleRules(true); });
  rules.querySelector(".opw-rules-back").addEventListener("click", function () { toggleRules(false); });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var email = form.email.value.trim();
    if (!form.email.checkValidity() || !email) return fail(httpError(400, "Tarkista sähköpostiosoite."));
    // Kaupan testiosoite (asetus paneelissa): loputon demo, ei palvelinkutsua, koodeja eikä tallennusta.
    if (cfg.testEmail && email.toLowerCase() === cfg.testEmail) demo = true;
    submitBtn.disabled = true;
    submitBtn.textContent = "Onnea matkaan!";
    msg.textContent = "";
    form.email.removeAttribute("aria-invalid");
    // Osoite tarkistetaan ennen pyöritystä: käytetystä tulee virhe lomakkeelle, eikä pyörä liiku turhaan.
    var check = demo ? Promise.resolve() : local ? localCheck(email) : post({ email: email, check: true });
    check.then(function () {
      startSpin();
      (demo ? demoSpin() : local ? localSpin(email) : post({ email: email, consent: true }))
        .then(function (data) {
          store.set(KEY_RESULT, data);
          if (data.win && data.code && !demo) applyDiscount(data.code);
          stopSpin(data.slice, DECEL_TURNS, function () { land(data); });
        })
        .catch(function (err) { stopSpin(null, 1, function () { fail(err); }); });
    }, fail);
  });

  function post(body) {
    var abort = new AbortController();
    var timer = setTimeout(function () { abort.abort(); }, 15000);
    return fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
      signal: abort.signal
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || !data.ok) throw httpError(res.status, data.error || "Jokin meni pieleen. Yritä hetken päästä uudelleen.");
          return data;
        });
      })
      .finally(function () { clearTimeout(timer); });
  }

  function httpError(status, text) {
    var err = new Error(text);
    err.status = status;
    return err;
  }

  // 400 = virheellinen osoite, 409 = osoitteella on jo pyöräytetty: kenttä merkitään ja valitaan vaihtoa varten.
  function fail(err) {
    var emailProblem = err.status === 400 || err.status === 409;
    msg.textContent = err.name === "AbortError" ? "Yhteys aikakatkaistiin. Yritä uudelleen."
      : err.status ? err.message : "Yhteys katkesi. Yritä uudelleen.";
    submitBtn.disabled = false;
    submitBtn.textContent = cfg.buttonText;
    if (!emailProblem) return;
    form.email.setAttribute("aria-invalid", "true");
    form.email.focus();
    form.email.select();
  }

  form.email.addEventListener("input", function () {
    if (!form.email.hasAttribute("aria-invalid")) return;
    form.email.removeAttribute("aria-invalid");
    msg.textContent = "";
  });

  // Pyöräytys on fysiikkaa, ei valmista animaatiota: taaksepäin veto (ennakointi), kiihdytys, tasainen
  // pyörintä niin kauan kuin palvelin vastaa, sitten hidastus samasta nopeudesta oikeaan lohkoon.
  // Hidastus on kaksivaiheinen: vauhti laskee pehmeästi ryömintään (OMEGA_CRAWL), jonka jälkeen pyörä
  // hiipuu tasaisella kitkalla CRAWL_MS:ssä. Näin loppu näkyy eikä pysähdys tunnu äkilliseltä.
  // Osoitin naksahtaa jokaisella lohkorajalla.
  var OMEGA = 1.3; // huippunopeus, astetta/ms
  var OMEGA_CRAWL = 0.1; // ryömintä, astetta/ms (noin kaksi lohkoa sekunnissa)
  var ACCEL_MS = 350, CRAWL_MS = 2000, DECEL_TURNS = 3;
  var theta = 0, spin = null;

  function startSpin() {
    if (reduceMotion) return;
    var t0 = performance.now(), from = theta, prev = t0, lastTick = tickIndex(theta), lastTickAt = t0;
    spin = { omega: 0, stop: null, decel: null };
    requestAnimationFrame(function frame(now) {
      var s = spin;
      if (!s) return;
      var t = now - t0, dt = Math.min(now - prev, 50);
      prev = now;
      if (t < PULL_MS) {
        theta = from - PULL_DEG * easeInOutCubic(t / PULL_MS);
      } else if (!s.decel) {
        s.omega = Math.min(OMEGA, s.omega + (OMEGA * dt) / ACCEL_MS);
        theta += s.omega * dt;
        if (s.stop && s.omega >= OMEGA) beginDecel(s, now);
      } else {
        var d = s.decel, e = now - d.start;
        if (e >= d.ta + CRAWL_MS) {
          theta = d.from + d.delta;
          setRotor(theta);
          spin = null;
          return s.stop.done();
        }
        theta = d.from + decelDistance(e, d.ta);
      }
      setRotor(theta);
      var k = tickIndex(theta);
      if (k !== lastTick) {
        flick(now - lastTickAt);
        lastTick = k;
        lastTickAt = now;
      }
      requestAnimationFrame(frame);
    });
  }

  // index null = pysähdy mihin tahansa (virhe tai aiempi pyöräytys).
  function stopSpin(index, turns, done) {
    if (!spin) {
      theta = landingAngle(theta, index);
      setRotor(theta);
      return done();
    }
    spin.stop = { index: index, turns: turns, done: done };
  }

  // Vaihe A (ta ms): nopeus v(u) = ω₁ + (ω₀ − ω₁)(1 − u)², pehmeä lasku huippunopeudesta ryömintään.
  // Vaihe B (CRAWL_MS): tasainen hidastuvuus ryöminnästä nollaan. Matka integroitu suljetussa muodossa,
  // ja ta ratkaistaan niin, että kokonaismatka osuu täsmälleen kohdelohkoon.
  var CRAWL_DIST = (OMEGA_CRAWL * CRAWL_MS) / 2;
  function beginDecel(s, now) {
    var dest = landingAngle(theta + 360 * s.stop.turns, s.stop.index);
    var delta = dest - theta;
    var ta = Math.max(0, (delta - CRAWL_DIST) / (OMEGA_CRAWL + (OMEGA - OMEGA_CRAWL) / 3));
    s.decel = { start: now, from: theta, delta: delta, ta: ta };
  }
  function decelDistance(e, ta) {
    var distA = ta * (OMEGA_CRAWL + (OMEGA - OMEGA_CRAWL) / 3);
    if (e < ta) {
      var u = e / ta;
      return ta * (OMEGA_CRAWL * u + ((OMEGA - OMEGA_CRAWL) * (1 - Math.pow(1 - u, 3))) / 3);
    }
    var w = (e - ta) / CRAWL_MS;
    return distA + OMEGA_CRAWL * CRAWL_MS * (w - (w * w) / 2);
  }

  function landingAngle(min, index) {
    if (index == null) return min;
    var base = (360 - index * sliceDeg) % 360; // aina lohkon keskelle, ei lähelle rajaviivaa
    return base + 360 * Math.ceil((min - base) / 360);
  }

  function easeInOutCubic(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function tickIndex(deg) { return Math.floor((deg + sliceDeg / 2) / sliceDeg); }

  function flick(interval) {
    pointer.animate([{ transform: "rotate(-24deg)" }, { transform: "rotate(0deg)" }], { duration: 150, easing: EASE_OUT });
    if (interval > 90 && navigator.vibrate) navigator.vibrate(5); // tuntuma vasta hitaassa vaiheessa
  }

  function land(data) {
    if (!data.win) return setTimeout(function () { showResult(data, false); }, reduceMotion ? 0 : 700);
    var slices = rotor.querySelectorAll(".opw-slice");
    for (var i = 0; i < slices.length; i++) if (i !== data.slice) slices[i].classList.add("opw-dim");
    // Voittolohkon ympärille valkoinen hehku (piirretään viimeisenä, jottei naapurilohko peitä sitä).
    var glow = document.createElementNS("http://www.w3.org/2000/svg", "path");
    glow.setAttribute("class", "opw-glow");
    glow.setAttribute("d", slices[data.slice].querySelector("path").getAttribute("d"));
    rotor.appendChild(glow);
    if (!reduceMotion) {
      confetti();
      if (navigator.vibrate) navigator.vibrate([30, 50, 60]);
    }
    setTimeout(function () { showResult(data, false); }, reduceMotion ? 0 : 450);
  }

  function confetti() {
    var canvas = document.createElement("canvas");
    canvas.className = "opw-confetti";
    canvas.setAttribute("aria-hidden", "true");
    dialog.appendChild(canvas);
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = innerWidth, H = innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    var g = canvas.getContext("2d");
    g.scale(dpr, dpr);
    var box = dialog.querySelector(".opw-wheel").getBoundingClientRect();
    var ox = box.left + box.width / 2, oy = box.top + box.height / 2;
    var colors = [cfg.accentColor, "#232323", "#ffffff"];
    var parts = [];
    for (var i = 0; i < 150; i++) {
      var ang = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.5, sp = 7 + Math.random() * 9;
      parts.push({ x: ox, y: oy, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, w: 6 + Math.random() * 5, h: 3 + Math.random() * 3,
        r: Math.random() * 6.3, vr: (Math.random() - 0.5) * 0.4, c: colors[i % colors.length] });
    }
    var start = performance.now(), prev = start, LIFE = 2600, FADE = 600;
    requestAnimationFrame(function tick(now) {
      var dt = Math.min((now - prev) / 16.67, 3), t = now - start; // aikapohjainen, ei hidastu kun freimejä putoaa
      prev = now;
      g.clearRect(0, 0, W, H);
      g.globalAlpha = t > LIFE - FADE ? Math.max(0, (LIFE - t) / FADE) : 1;
      parts.forEach(function (p) {
        p.vx *= Math.pow(0.985, dt);
        p.vy = p.vy * Math.pow(0.985, dt) + 0.32 * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.r += p.vr * dt;
        g.save();
        g.translate(p.x, p.y);
        g.rotate(p.r);
        g.fillStyle = p.c;
        g.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 1.7)) + 0.6); // lepatus
        g.restore();
      });
      if (t < LIFE) requestAnimationFrame(tick);
      else canvas.remove();
    });
  }

  function showResult(data, repeat) {
    resultPane.innerHTML = resultHtml(data, repeat);
    resultPane.classList.toggle("opw-center", !(data.win && data.code)); // lyhyt sisältö keskelle, ei tyhjää alaosaa
    formPane.inert = true;
    resultPane.inert = false;
    resultPane.classList.remove("opw-show");
    void resultPane.offsetWidth; // käynnistää sisääntulon uudelleen
    resultPane.classList.add("opw-show");
    resultPane.focus();
    var copy = resultPane.querySelector(".opw-copy");
    if (copy) copy.addEventListener("click", function () {
      navigator.clipboard.writeText(data.code).then(function () { copy.textContent = "Kopioitu"; }, function () {
        getSelection().selectAllChildren(resultPane.querySelector(".opw-code span"));
      });
    });
    var doneBtn = resultPane.querySelector(".opw-done");
    if (doneBtn) doneBtn.addEventListener("click", function () { dialog.close(); });
    if (demo) again.hidden = false;
  }

  // Voittokoodi ostoskoriin heti voiton hetkellä (Shopifyn discount_code-eväste), joten kävijän ei tarvitse
  // etsiä koodia myöhemmin. Uudelleenohjausta ei seurata, joten sivua ei ladata turhaan.
  function applyDiscount(code) {
    fetch(root + "discount/" + encodeURIComponent(code), { redirect: "manual", credentials: "same-origin" }).catch(function (err) {
      console.warn("[onnenpyora] alennuksen lisäys ostoskoriin epäonnistui, koodi näkyy ruudulla", err); // ei kriittinen
    });
  }

  // Demon arvonta: tasainen todennäköisyys lohkoille (oikeat todennäköisyydet eivät ole selaimessa).
  function demoSpin() {
    var i = Math.floor(Math.random() * n), label = cfg.slices[i].label;
    var rule = cfg.rules.filter(function (p) { return p.label === label; })[0];
    var data = rule
      ? { ok: true, win: true, slice: i, amount: rule.amount, minSubtotal: rule.minSubtotal, code: "ONNI" + rule.amount + "-DEMO",
          expiresAt: cfg.codeValidDays ? new Date(Date.now() + cfg.codeValidDays * DAY).toISOString() : null }
      : { ok: true, win: false, slice: i };
    return new Promise(function (resolve) { setTimeout(resolve, 600 + Math.random() * 600, data); });
  }

  function localCheck(email) {
    var used = store.get(KEY_USED) || [];
    return used.indexOf(email.toLowerCase()) < 0 ? Promise.resolve()
      : Promise.reject(httpError(409, "Tällä sähköpostiosoitteella on jo pyöräytetty. Kokeile toista osoitetta."));
  }

  // ponytail: osoiteraja vain tässä selaimessa (ei palvelinta), kuten tukun aiempi pyörä. Kiinteät koodit on rajattu
  // Shopifyssa kerran asiakasta kohden, joten toisella selaimella pyörittäminen ei anna toista alennusta samalle asiakkaalle.
  function localSpin(email) {
    var key = email.toLowerCase(), prizes = local.prizes, prize = prizes[prizes.length - 1];
    store.set(KEY_USED, (store.get(KEY_USED) || []).concat(key));
    var roll = Math.random() * prizes.reduce(function (sum, p) { return sum + p.chance; }, 0);
    for (var i = 0; i < prizes.length; i++) {
      if (roll < prizes[i].chance) { prize = prizes[i]; break; }
      roll -= prizes[i].chance;
    }
    var matches = [];
    cfg.slices.forEach(function (s, j) { if (s.amount === prize.amount) matches.push(j); });
    var data = { ok: true, win: prize.amount > 0, amount: prize.amount, minSubtotal: prize.minSubtotal, code: prize.code || null,
      expiresAt: null, slice: matches[Math.floor(Math.random() * matches.length)] };
    document.dispatchEvent(new CustomEvent("onnenpyora:spin", { detail: { email: key, win: data.win, amount: data.amount, code: data.code } }));
    return new Promise(function (resolve) { setTimeout(resolve, 600 + Math.random() * 600, data); });
  }

  var again = dialog.querySelector(".opw-again");
  function reset() {
    var dims = rotor.querySelectorAll(".opw-dim");
    for (var i = 0; i < dims.length; i++) dims[i].classList.remove("opw-dim");
    var glow = rotor.querySelector(".opw-glow");
    if (glow) glow.remove();
    resultPane.classList.remove("opw-show", "opw-center");
    resultPane.innerHTML = resultHtml(sizer, false);
    resultPane.inert = true;
    formPane.inert = false;
    submitBtn.disabled = false;
    submitBtn.textContent = cfg.buttonText;
    msg.textContent = "";
    again.hidden = true;
  }
  again.addEventListener("click", function () {
    reset();
    form.email.focus();
  });

  // Ei avata Shopifyn evästebannerin päälle: odotetaan, että kävijä vastaa siihen.
  function openWhenFree() {
    var banner = document.getElementById("shopify-pc__banner");
    if (banner && banner.getClientRects().length && getComputedStyle(banner).visibility !== "hidden") {
      return setTimeout(openWhenFree, 1500);
    }
    if (!dialog.open) open();
  }

  // Viive lasketaan koko käynnin alusta (välilehden sessio), ei jokaiselta sivulta erikseen:
  // muuten sivua vaihtava kävijä ei koskaan näkisi pyörää.
  function visitStart() {
    try {
      var start = Number(sessionStorage.getItem(KEY_START));
      if (start) return start;
      sessionStorage.setItem(KEY_START, String(Date.now()));
    } catch (e) { /* yksityinen tila: lasketaan tältä sivulta */ }
    return Date.now();
  }

  function init() {
    document.body.appendChild(dialog);
    // Kelluva avausnappi vain esikatselussa (teemaeditori, sovelluksen esikatselu). Kävijälle suljettu pyörä pysyy kiinni.
    if (preview) {
      document.body.appendChild(launcher);
      return open();
    }
    var seen = store.get(KEY_SEEN) || 0;
    var due = Date.now() - seen >= cfg.repeatDays * DAY;
    var onCart = /\/cart\/?$/.test(location.pathname);
    if (store.get(KEY_RESULT) || !due || onCart) return;
    setTimeout(openWhenFree, Math.max(0, cfg.delaySeconds * 1000 - (Date.now() - visitStart())));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
